import { Button, Modal } from 'react-bootstrap';
import CloseIcon from '../../SVG/CloseIcon';
import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import OtpInput from 'react-otp-input';
import { postRequest } from '../../../helpers/apiHandler';
import { useDispatch, useSelector } from 'react-redux';
import { reloadTopbar } from '../../../store/actions/reduxAction';

const ChangeMobileNumberModal = ({ show, setModalShow, oldPhone, setPhoneNumber, setAlertState }) => {
  const dispatch = useDispatch();
  const { access_token } = useSelector((state) => state.auth.user)

  const [newPhone, setNewPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [hasSendOtp, setHasSendOtp] = useState(false);
  const TIMER = 30000;


  const handleClose = () => {
    setOtp('')
    setNewPhone('');
    setHasSendOtp(false);
    setModalShow(false);
  };

  const handleOtpChange = value => {
    setOtp(value);
  };

  const handleOtpActivation = () => {
    const data = {
      phone_number: newPhone,
      country_iso: 'MY',
      is_updating: oldPhone !== newPhone,
    };
    console.log({ oldPhone, newPhone })
    postRequest(`/auth/request-otp`, data, access_token.token, res => {
      if (res.success) {
        setHasSendOtp(true);
        setAlertState({
          message: res.message,
          show: true,
          variant: 'success',
        });
      } else {
        setHasSendOtp(false);
        setAlertState({
          message: res.message,
          show: true,
          variant: 'danger',
        });
      }
    });
  }

  const handleNewPhoneChange = num => {
    setNewPhone(num)
  }

  const handleVerifyOtp = () => {
    const data = { otp_code: otp, is_updating: oldPhone !== newPhone };

    postRequest(`/auth/validate-otp`, data, access_token.token, res => {
      if (res.success) {
        const { active, phone_active } = res.data;
        if (phone_active && active) {
          setAlertState({
            message: 'Phone number successfully updated',
            show: true,
            variant: 'success',
          });
          // Close the modal, dispatch reload, setPhoneNumber
          dispatch(reloadTopbar());
          setPhoneNumber(newPhone);
          handleClose();
        }
      } else {
        setAlertState({
          message: res.message,
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  useEffect(() => {
    if (hasSendOtp) {
      setTimeout(() => {
        setHasSendOtp(false);
      }, TIMER);
    }
  }, [hasSendOtp]);

  return <>
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="sms-detail-modal">
        <CloseIcon handleModalClose={handleClose} />
        <i className='fa fas fa-exclamation-triangle fa-warning' />
        <Modal.Title as="h4" style={{ margin: '16px 0 8px 8px' }}>
          Change Mobile Number
        </Modal.Title>
        <p className="change-mobile-subtitle">Enter your NEW mobile number below to receive your one-time password (OTP).</p>
        <div className="change-mobile-wrapper">
          <div className="phone-number-wrapper">
            <PhoneInput
              international
              placeholder="Enter mobile number"
              defaultCountry="MY"
              value={newPhone}
              onChange={handleNewPhoneChange}
            />
            <Button
              variant="primary"
              style={{ minWidth: 125 }}
              onClick={handleOtpActivation}
              disabled={hasSendOtp}
              className='btn-phone-verification'
            >
              Send
            </Button>
          </div>
          <div className="divider-line" style={{ width: '100%' }} />
          <h4 style={{ fontSize: 16 }}>Enter your one time password</h4>
          <OtpInput
            value={otp}
            onChange={handleOtpChange}
            numInputs={4}
            renderInput={props => <input {...props} />}
            containerStyle="otp-wrapper"
            inputStyle="otp-input"
          />
          <div
            className="d-flex justify-content-center align-items-center w-100">
            <Button variant="primary" style={{ minWidth: 160 }}
              onClick={handleVerifyOtp}>
              Verify
            </Button>
          </div>

          <p>
            Need help? Reach out to our <a
              href="mailto:elfoa2psupport@elfo.com">Support
              Team</a>
          </p>
        </div>
      </Modal.Body>
    </Modal>
  </>
}

export default ChangeMobileNumberModal;
